import { render, staticRenderFns } from "./MedicalCompanionForm.vue?vue&type=template&id=3c5577dc&"
import script from "./MedicalCompanionForm.vue?vue&type=script&lang=js&"
export * from "./MedicalCompanionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports